const dashboardApis = {
  get_candidates: '/api/potential-candidate-handbook/get-candidates',
  toggle_favorite: '/api/potential-candidate-handbook/toggle-favorite',
};

export default dashboardApis;
